import React, { useRef, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

const NextPreviousButton = styled.button`
    font-size: 34px;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    height: 100%;
    width: 50px;

    .arrow-icon {
        position: relative;
        width: 34px;
        height: 34px;
        color: black;
        border-radius: 50%;
    }
`

export const NextButton = styled(NextPreviousButton)`
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
`

export const PreviousButton = styled(NextPreviousButton)`
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
`
